import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Link from 'gatsby-link';
import { media } from '../../utils/style';
import H4 from '../H4';
import P from '../P';
import ResponsiveImg from '../ResponsiveImg';

const ProjectImg = styled.div`
  &:after {
    background-color: rgba(0, 0, 0, 0.05);
    bottom: 0;
    content: '';
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
  }
`;

const ProjectCopy = styled.div`
  background: ${props =>
    `linear-gradient(transparent, rgba(0, 0, 0, .7), ${props.theme.black})`};
  bottom: 0;
  left: 0;
  padding: 35px 10px 10px;
  position: absolute;
  right: 0;
  text-align: left;
  transition: padding 0.35s;

  p {
    margin: 0;
  }
`;

const ProjectWrap = styled.div`
  margin: 15px auto;
  overflow: hidden;
  position: relative;
  width: 100%;
  ${props =>
    props.portrait
      ? css`
          max-width: 350px;
        `
      : ''} ${media.desktop`
    margin: 0 0.5%;
    width: ${props => (props.portrait ? '24%' : '49%')};
  `}

  a {
    display: block;

    &:hover,
    &:focus {
      ${ProjectCopy} {
        padding-bottom: 20px;
        padding-top: 25px;
      }
    }
  }
`;

const Project = ({ link, title, description, image, portrait }) => (
  <ProjectWrap portrait={portrait}>
    <Link to={link} title={`Visit ${title} Project Page`}>
      <ProjectImg>
        <ResponsiveImg src={image} alt={description} />
      </ProjectImg>
      <ProjectCopy>
        <H4 inverse>{title}</H4>
        <P inverse>{description}</P>
      </ProjectCopy>
    </Link>
  </ProjectWrap>
);

Project.propTypes = {
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired
};

export default Project;



// WEBPACK FOOTER //
// ./src/components/ProjectComponents/Project.js